const header = document.getElementById('shopify-section-header');
const featuredSearchBanner = document.querySelector('.featured-search-banner-wrap');
if (featuredSearchBanner != null && !Shopify.isHeaderSticky) {
  header.style.position = 'static';
  featuredSearchBanner.classList.add('pageTop');
}

const pathName = window.location.pathname;

if (pathName === '/') {
  header.classList.add('fixed-top');
}

class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }

  closeMenuDisclosure() {
    this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
    this.disclosures.forEach((disclosure) => disclosure.close());
  }

  closeSearchModal() {
    this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    this.searchModal.close(false);
  }
}

customElements.define('sticky-header', StickyHeader);

function openMenu() {
  $('#modalMenu').closest('.remodal-wrapper').css('display', 'block');
  $('.remodal-overlay').css('display', 'block');
}

const headerMenu = document.getElementById('headerMenu');

if (headerMenu) {
  headerMenu.addEventListener('click', function () {
    openMenu();
  });
}
document.addEventListener(
  'DOMContentLoaded',
  () => {
    // SPのメニュー用のオーバーレイを作成
    const menuDrawerOverlay = document.createElement('div');
    menuDrawerOverlay.classList.add('menu-drawer-overlay');
    document.body.appendChild(menuDrawerOverlay);

    function closeMenu() {
      document.querySelector('.menu-drawer-container').classList.remove('menu-opening');
      document.querySelector('.menu-drawer-container').removeAttribute('open');
      const loginBanner = document.querySelector('.featured-login-banner');
      if (loginBanner) {
        loginBanner.classList.remove('is-sentToBack');
        loginBanner.style.zIndex = '';
      }
      document.querySelector('.menu-drawer-overlay').style.display = 'none';
      document.querySelector('.icon-close-wrapper').style.display = 'none';
      document.getElementById('menu-drawer')?.classList.remove('open');
      document.body.style.overflow = 'auto';
    }

    document.querySelector('.menu-drawer-overlay')?.addEventListener('click', function () {
      closeMenu();
    });
    document.querySelector('.icon-close-wrapper')?.addEventListener('click', function () {
      closeMenu();
    });

    $('.remodal.search-menu-block').removeAttr('style');
    var login_banner_available = $('.featured-login-banner-wrap').children().length > 0 ? true : false;
    sc_func();

    if (!login_banner_available) {
      $('.featured-login-banner-wrap').height(0);
    }
    // SP用のメニューアイコンをクリックしたときの処理
    $('.header-drawer').on('click', function () {
      $('.featured-login-banner').removeClass('fixed');
      if (login_banner_available) {
        $('.featured-login-banner-wrap').removeClass('is-content-fixed');
      }
      document.body.style.overflow = 'hidden';
      document.querySelector('.icon-close-wrapper').style.display = 'block';
      document.querySelector('.menu-drawer-overlay').style.display = 'block';
      document.getElementById('menu-drawer')?.classList.add('open');
    });
    $('.header-search').on('click', function () {
      $('.featured-login-banner').removeClass('fixed');
      if (login_banner_available) {
        $('.featured-login-banner-wrap').removeClass('is-content-fixed');
      }
    });

    // adjusting remodal plugin to fix modal opening judder
    document.body.setAttribute('data-scrollbarW', window.innerWidth - document.body.clientWidth);
    let pantryMainSwiper = null;
    let pantryThumbSwiper = null;
    $(document).on('opened', '.remodal', function () {
      document.body.style.paddingRight =
        Number(document.body.dataset.scrollbarw) > 0 ? document.body.dataset.scrollbarw + 'px' : '0';
      const productPantryFixedElement = document.querySelector('.product-pantry-fixed');
      if (productPantryFixedElement) {
        productPantryFixedElement.style.display = 'none';
      }
      const modalElement = $(this);
      if (modalElement.data('name') === 'pantry-child-product-modal') {
        const productId = modalElement.data('product_id');
        this.querySelector(`[data-name="pantry-swiper-wrapper-${productId}"]`).style.display = 'block';
        pantryThumbSwiper = new Swiper(`.pantry-swiper-thumb-slide-${productId}`, {
          spaceBetween: 10,
          slidesPerView: 5,
          freeMode: true,
          lazy: {
            loadPrevNext: true,
          },
          on: {
            init: function () {
              const actualSlidesCount = this.el.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)').length;
              if (actualSlidesCount <= 1) {
                const thumbnailSliders = document.querySelectorAll(`.pantry-swiper-thumb-slide-${productId}`);
                for (const element of thumbnailSliders) {
                  element.style.display = 'none';
                }
                return;
              }
              if (actualSlidesCount <= 4) {
                const thumbnailSliders = document.querySelectorAll(`.pantry-swiper-thumb-slide-${productId}`);
                for (const element of thumbnailSliders) {
                  element.querySelector(`.pantry-swiper-thumb-wrapper`).classList.add('pantry-swiper-thumb-center');
                }
              }
            },
          },
        });
        pantryMainSwiper = new Swiper(`.pantry-swiper-main-slide-${productId}`, {
          slidesPerView: 1,
          freeMode: true,
          effect: 'fade',
          lazy: {
            loadPrevNext: true,
          },
          fadeEffect: {
            crossFade: true,
          },
          thumbs: {
            swiper: pantryThumbSwiper,
          },
          on: {
            init: function () {
              const actualSlidesCount = this.el.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)').length;
              if (actualSlidesCount <= 1) {
                this.params.allowTouchMove = false;
                this.update();
              }
            },
          },
        });
      }
    });
    $(document).on('closed', '.remodal', function () {
      document.body.style.paddingRight = '0';
      const productPantryFixedElement = document.querySelector('.product-pantry-fixed');
      if (productPantryFixedElement) {
        productPantryFixedElement.style.display = 'block';
      }
      const modalElement = $(this);
      if (modalElement.data('name') === 'pantry-child-product-modal') {
        if (pantryThumbSwiper) {
          pantryThumbSwiper.destroy();
        }
        if (pantryMainSwiper) {
          pantryMainSwiper.destroy();
        }
      }
    });
    function sc_func() {
      var noticeH = $('#shopify-section-announcement-bar').height();
      var bannerH = $('.featured-login-banner').height();
      var minH = noticeH + bannerH;

      // 元々の位置を取得
      var posBf = $(window).scrollTop();

      $(window).scroll(function () {
        // スクロールしたら位置を取得
        var posAf = $(this).scrollTop();
        posAf = posAf > minH ? posAf : minH;
        // 元々の位置とスクロール後の位置を比較
        if (posAf < posBf) {
          $('.featured-login-banner').addClass('fixed');
          if (login_banner_available) {
            $('.featured-login-banner-wrap').addClass('is-content-fixed');
          }
        } else {
          $('.featured-login-banner').removeClass('fixed');
          if (login_banner_available) {
            $('.featured-login-banner-wrap').removeClass('is-content-fixed');
          }
        }
        // 元々の位置をスクロール後の位置に書き換える
        posBf = posAf;
      });
    }
  },
  false,
);
